import Vue from 'vue'
import './plugins/vuetify'
import './plugins/base'
import App from './App.vue'
import store from './store'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.min.css'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
Vue.config.productionTip = false

const vuetifyOptions = {
  theme: {
    primary: '#D3C3BC',
    secondary: '#BFADA5',
    accent: '#D8EBF1',
    info: '#869b36'
  },
  iconfont: 'mdi'
}

new Vue({ // eslint-disable-line no-new
  el: '#app',
  store,
  render: h => h(App),
  vuetify: new Vuetify(vuetifyOptions)
})
